/*
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file has been auto-generated. Any modifications
 * you make will be overwritten when the file is regenerated.
 *
 * For more information or questions, please go to #design-eng
 *
 */

/*
 * Base 2.0 Color Token Naming Convention
 * =======================================
 *
 * Canonical form:  [family]-[role]-[context]-[hierarchy]-[variant]-[state]
 * Components are omitted when implicit (neutral family, default context, etc.)
 *
 *   Family:    accent, error, warning, success, info (neutral is implicit)
 *   Role:      background, content, border
 *   Context:   inverse (default is implicit)
 *   Hierarchy: primary, secondary, tertiary
 *   Variant:   bold, subtle, disabled, onbold, onsubtle, oninverse,
 *              statelayer, decorative, accessible
 *   State:     hover, pressed
 *
 * Product extensions (ai, eats, etc.) provide sparse overrides via
 * separate exported functions — merge with base semantics at runtime.
 *
 * Platform formats:
 *   TS/Swift/Compose: backgroundPrimary, accentContentPrimaryOnbold
 *   CSS:              --background-primary, --accent-content-primary-onbold
 */

/* Primitive color tokens v2
 * **DO NOT USE DIRECTLY**
 * Use semantic color tokens instead.
 */
export const primitiveColorTokensV2 = ({
  amber0: '#000000',
  amber15: '#120800',
  amber18: '#1D1001',
  amber23: '#2A1800',
  amber27: '#372000',
  amber31: '#442A02',
  amber35: '#523303',
  amber40: '#603C02',
  amber44: '#6F4603',
  amber48: '#7F5001',
  amber53: '#8D5C0C',
  amber57: '#9E6605',
  amber61: '#AF7212',
  amber66: '#C27E04',
  amber70: '#D18B07',
  amber74: '#DF9906',
  amber79: '#EDA803',
  amber83: '#F6B924',
  amber87: '#FEC95D',
  amber91: '#FEDA94',
  amber96: '#FEE9C0',
  amber98: '#FFF5E3',
  amber99: '#FFFCF7',
  amber100: '#FFFFFF',
  blue0: '#000000',
  blue15: '#000A1D',
  blue18: '#00112A',
  blue23: '#011C3D',
  blue27: '#02264F',
  blue31: '#003062',
  blue35: '#033A74',
  blue40: '#074688',
  blue44: '#08519C',
  blue48: '#0A5DB3',
  blue53: '#0669C9',
  blue57: '#1175DD',
  blue61: '#1185E8',
  blue66: '#1195F2',
  blue70: '#33A3FC',
  blue74: '#59B0FD',
  blue79: '#79BDFC',
  blue83: '#93CAFE',
  blue87: '#AFD7FD',
  blue91: '#C8E4FE',
  blue96: '#DFEFFE',
  blue98: '#F0F7FF',
  blue99: '#FBFDFF',
  blue100: '#FFFFFF',
  gradientBlue0: '#01233F',
  gradientBlue15: '#012849',
  gradientBlue18: '#022D52',
  gradientBlue23: '#03325D',
  gradientBlue27: '#043768',
  gradientBlue31: '#043C74',
  gradientBlue35: '#054181',
  gradientBlue40: '#06458F',
  gradientBlue44: '#074A9E',
  gradientBlue48: '#094EAD',
  gradientBlue53: '#044FC4',
  gradientBlue57: '#014FDD',
  gradientBlue61: '#0E4FF2',
  gradientBlue66: '#2355FA',
  gradientBlue70: '#355EFB',
  gradientBlue74: '#4466FC',
  gradientBlue79: '#526EFD',
  gradientBlue83: '#5E75FE',
  gradientBlue87: '#6C7EFA',
  gradientBlue91: '#7785FC',
  gradientBlue96: '#828CFE',
  gradientBlue98: '#8E94FB',
  gradientBlue99: '#989BFE',
  gradientBlue100: '#A2A3FD',
  gradientIndigo0: '#0C088C',
  gradientIndigo15: '#140696',
  gradientIndigo18: '#1B02A1',
  gradientIndigo23: '#220BA5',
  gradientIndigo27: '#2905B0',
  gradientIndigo31: '#2F0FB5',
  gradientIndigo35: '#3608BF',
  gradientIndigo40: '#3D11C4',
  gradientIndigo44: '#4509CF',
  gradientIndigo48: '#4C13D4',
  gradientIndigo53: '#541BD8',
  gradientIndigo57: '#5C21DC',
  gradientIndigo61: '#6427E1',
  gradientIndigo66: '#6E2CE5',
  gradientIndigo70: '#7732E9',
  gradientIndigo74: '#8137ED',
  gradientIndigo79: '#8C3CF1',
  gradientIndigo83: '#9740F4',
  gradientIndigo87: '#A245F7',
  gradientIndigo91: '#AD4AFA',
  gradientIndigo96: '#B84EFC',
  gradientIndigo98: '#C453FE',
  gradientIndigo99: '#CC5DFB',
  gradientIndigo100: '#D761FD',
  gradientRed0: '#46021A',
  gradientRed15: '#53031F',
  gradientRed18: '#600424',
  gradientRed23: '#6E0428',
  gradientRed27: '#7D012D',
  gradientRed31: '#8A0831',
  gradientRed35: '#9A0134',
  gradientRed40: '#A80737',
  gradientRed44: '#B70E37',
  gradientRed48: '#C61432',
  gradientRed53: '#D90220',
  gradientRed57: '#E32112',
  gradientRed61: '#E83C13',
  gradientRed66: '#ED4F17',
  gradientRed70: '#F65B07',
  gradientRed74: '#FA6B16',
  gradientRed79: '#FD7924',
  gradientRed83: '#FD893D',
  gradientRed87: '#FE9752',
  gradientRed91: '#FCA569',
  gradientRed96: '#FFB179',
  gradientRed98: '#FFBD8C',
  gradientRed99: '#FECAA0',
  gradientRed100: '#FFD5B2',
  green0: '#000000',
  green15: '#000F01',
  green18: '#001702',
  green23: '#012406',
  green27: '#01300C',
  green31: '#013C14',
  green35: '#00491C',
  green40: '#095627',
  green44: '#05632F',
  green48: '#10723A',
  green53: '#098042',
  green57: '#17904E',
  green61: '#11A156',
  green66: '#1DB061',
  green70: '#06C167',
  green74: '#32CE73',
  green79: '#55D981',
  green83: '#75E190',
  green87: '#94E9A2',
  green91: '#B3F3B7',
  green96: '#CCFBCB',
  green98: '#E6FFE3',
  green99: '#F8FFF7',
  green100: '#FFFFFF',
  indigo0: '#000000',
  indigo15: '#0A0421',
  indigo18: '#11082F',
  indigo23: '#1C1044',
  indigo27: '#261858',
  indigo31: '#301F6B',
  indigo35: '#3B277F',
  indigo40: '#462F97',
  indigo44: '#5137AC',
  indigo48: '#5D44BD',
  indigo53: '#6852CB',
  indigo57: '#745FDA',
  indigo61: '#7F6CE8',
  indigo66: '#8B79F7',
  indigo70: '#988AFC',
  indigo74: '#A59BFD',
  indigo79: '#B2ACFC',
  indigo83: '#BFBBFE',
  indigo87: '#CECCFD',
  indigo91: '#DDDCFE',
  indigo96: '#EBEAFE',
  indigo98: '#F6F5FF',
  indigo99: '#FCFCFF',
  indigo100: '#FFFFFF',
  lime0: '#000000',
  lime15: '#040E00',
  lime18: '#081601',
  lime23: '#102201',
  lime27: '#182E02',
  lime31: '#203900',
  lime35: '#294502',
  lime40: '#335203',
  lime44: '#3D5E00',
  lime48: '#496B0A',
  lime53: '#547803',
  lime57: '#60850B',
  lime61: '#6B9313',
  lime66: '#77A019',
  lime70: '#84B008',
  lime74: '#91C012',
  lime79: '#9DCF18',
  lime83: '#AADD32',
  lime87: '#B9EA53',
  lime91: '#CCF484',
  lime96: '#DEFBB0',
  lime98: '#ECFFD1',
  lime99: '#FAFFF2',
  lime100: '#FFFFFF',
  magenta0: '#000000',
  magenta15: '#1B000C',
  magenta18: '#270114',
  magenta23: '#38021F',
  magenta27: '#4B012B',
  magenta31: '#5B0336',
  magenta35: '#6E0141',
  magenta40: '#81044E',
  magenta44: '#940359',
  magenta48: '#A90267',
  magenta53: '#BA1073',
  magenta57: '#C9277F',
  magenta61: '#D8388C',
  magenta66: '#E84899',
  magenta70: '#F757A6',
  magenta74: '#FC74B3',
  magenta79: '#FD8DBE',
  magenta83: '#FDA5CA',
  magenta87: '#FEBCD6',
  magenta91: '#FED2E3',
  magenta96: '#FEE4EE',
  magenta98: '#FFF3F7',
  magenta99: '#FFFBFD',
  magenta100: '#FFFFFF',
  membership0: '#000000',
  membership15: '#100803',
  membership18: '#1E0F00',
  membership23: '#2B1701',
  membership27: '#382001',
  membership31: '#452902',
  membership35: '#533204',
  membership40: '#623C02',
  membership44: '#704502',
  membership48: '#7E500B',
  membership53: '#8E5A09',
  membership57: '#9F6402',
  membership61: '#AD711D',
  membership66: '#BC7F2F',
  membership70: '#CC8E40',
  membership74: '#DC9D50',
  membership79: '#EBAB5E',
  membership83: '#F9B96C',
  membership87: '#FECA87',
  membership91: '#FEDBA9',
  membership96: '#FEEAC8',
  membership98: '#FFF5E1',
  membership99: '#FFFCF6',
  membership100: '#FFFFFF',
  neutral0: '#000000',
  neutral15: '#0A0A0A',
  neutral18: '#111111',
  neutral23: '#1C1C1C',
  neutral27: '#272727',
  neutral31: '#313131',
  neutral35: '#3B3B3B',
  neutral40: '#474747',
  neutral44: '#525252',
  neutral48: '#5F5F5F',
  neutral53: '#6B6B6B',
  neutral57: '#777777',
  neutral61: '#838383',
  neutral66: '#909090',
  neutral70: '#9D9D9D',
  neutral74: '#AAAAAA',
  neutral79: '#B7B7B7',
  neutral83: '#C4C4C4',
  neutral87: '#D2D2D2',
  neutral91: '#E0E0E0',
  neutral96: '#ECECEC',
  neutral98: '#F6F6F6',
  neutral99: '#FCFCFC',
  neutral100: '#FFFFFF',
  orange0: '#000000',
  orange15: '#180400',
  orange18: '#260800',
  orange23: '#340F00',
  orange27: '#421701',
  orange31: '#502002',
  orange35: '#602800',
  orange40: '#6E3202',
  orange44: '#7C3C08',
  orange48: '#8D4603',
  orange53: '#9C5109',
  orange57: '#AC5C10',
  orange61: '#C16808',
  orange66: '#D47614',
  orange70: '#EC8102',
  orange74: '#FC9026',
  orange79: '#FEA65D',
  orange83: '#FFB984',
  orange87: '#FECAA4',
  orange91: '#FED9BE',
  orange96: '#FFE8D6',
  orange98: '#FFF4EC',
  orange99: '#FFFCF9',
  orange100: '#FFFFFF',
  purple0: '#000000',
  purple15: '#120022',
  purple18: '#1B0031',
  purple23: '#290245',
  purple27: '#370459',
  purple31: '#45026F',
  purple35: '#520782',
  purple40: '#63009C',
  purple44: '#7010AE',
  purple48: '#8112C7',
  purple53: '#8E29D5',
  purple57: '#9B3AE3',
  purple61: '#A84AF2',
  purple66: '#B45DFB',
  purple70: '#BC76FB',
  purple74: '#C58AFC',
  purple79: '#CD9FFC',
  purple83: '#D7B1FD',
  purple87: '#E0C4FD',
  purple91: '#EAD7FE',
  purple96: '#F2E7FE',
  purple98: '#F9F4FF',
  purple99: '#FDFCFF',
  purple100: '#FFFFFF',
  red0: '#000000',
  red15: '#1B0100',
  red18: '#280200',
  red23: '#3A0501',
  red27: '#4E0600',
  red31: '#5E0C02',
  red35: '#720D00',
  red40: '#851402',
  red44: '#9B1B06',
  red48: '#B4230B',
  red53: '#CC2609',
  red57: '#E42500',
  red61: '#F3381B',
  red66: '#FC4F34',
  red70: '#FC6A52',
  red74: '#FD8069',
  red79: '#FE9783',
  red83: '#FEAC9C',
  red87: '#FEC1B5',
  red91: '#FED5CD',
  red96: '#FEE6E1',
  red98: '#FFF4F1',
  red99: '#FFFCFB',
  red100: '#FFFFFF',
  taupe0: '#000000',
  taupe15: '#0D0905',
  taupe18: '#15110B',
  taupe23: '#211B14',
  taupe27: '#2C261E',
  taupe31: '#363027',
  taupe35: '#413A32',
  taupe40: '#4D463D',
  taupe44: '#585148',
  taupe48: '#655E54',
  taupe53: '#716A60',
  taupe57: '#7D766C',
  taupe61: '#8A8278',
  taupe66: '#978F85',
  taupe70: '#A49C92',
  taupe74: '#B2AAA0',
  taupe79: '#C0B8AE',
  taupe83: '#CEC5BB',
  taupe87: '#DBD3C8',
  taupe91: '#E9E0D7',
  taupe96: '#F3ECE4',
  taupe98: '#FBF6EF',
  taupe99: '#FFFCF9',
  taupe100: '#FFFFFF',
  teal0: '#000000',
  teal15: '#000D11',
  teal18: '#00151A',
  teal23: '#012127',
  teal27: '#012D33',
  teal31: '#03383E',
  teal35: '#00444B',
  teal40: '#035157',
  teal44: '#025E63',
  teal48: '#016C71',
  teal53: '#0F7A7E',
  teal57: '#06888C',
  teal61: '#13959A',
  teal66: '#1CA3A8',
  teal70: '#06B2B8',
  teal74: '#2AC0C5',
  teal79: '#3FCED3',
  teal83: '#54DBE0',
  teal87: '#7AE6EA',
  teal91: '#A5F0F2',
  teal96: '#C9F7F8',
  teal98: '#E3FDFD',
  teal99: '#F6FFFF',
  teal100: '#FFFFFF',
  yellow0: '#000000',
  yellow15: '#0F0900',
  yellow18: '#1A1200',
  yellow23: '#251B00',
  yellow27: '#302502',
  yellow31: '#3C2E01',
  yellow35: '#483902',
  yellow40: '#554301',
  yellow44: '#614E01',
  yellow48: '#6E5A0B',
  yellow53: '#7B6609',
  yellow57: '#897202',
  yellow61: '#977F0F',
  yellow66: '#A78D02',
  yellow70: '#B79B10',
  yellow74: '#C6AA1A',
  yellow79: '#D4B71F',
  yellow83: '#E3C522',
  yellow87: '#F1D223',
  yellow91: '#FFDE21',
  yellow96: '#FEEB90',
  yellow98: '#FFF5C6',
  yellow99: '#FFFCED',
  yellow100: '#FFFFFF'
} as const);
export type PrimitiveColorTokensV2Type = typeof primitiveColorTokensV2;
interface PrimitivesParam {
  [key: string]: string;
}

/*
 * Semantic color tokens v2, light mode
 */
export const semanticColorTokensV2Light = (primitives: PrimitivesParam) => ({
  backgroundBase: primitives.neutral99,
  backgroundPrimary: primitives.neutral100,
  backgroundSecondary: primitives.neutral98,
  backgroundTertiary: primitives.neutral96,
  backgroundDisabled: 'rgba(224, 224, 224, 0.6)',
  backgroundAlwaysDark: primitives.neutral0,
  backgroundAlwaysLight: primitives.neutral100,
  backgroundTrack: 'rgba(107, 107, 107, 0.06)',
  errorBackgroundBold: primitives.red53,
  errorBackgroundSubtle: primitives.red96,
  errorBackgroundDisabled: 'rgba(254, 230, 225, 0.75)',
  errorBackgroundStatelayerHover: 'rgba(254, 230, 225, 0.25)',
  errorBackgroundStatelayerPressed: 'rgba(254, 230, 225, 0.5)',
  warningBackgroundBold: primitives.orange74,
  warningBackgroundSubtle: primitives.orange96,
  warningBackgroundDisabled: 'rgba(255, 232, 214, 0.75)',
  successBackgroundBold: primitives.green53,
  successBackgroundSubtle: primitives.green98,
  successBackgroundDisabled: 'rgba(204, 251, 203, 0.75)',
  infoBackgroundBold: primitives.neutral18,
  infoBackgroundSubtle: primitives.neutral96,
  infoBackgroundDisabled: 'rgba(224, 224, 224, 0.75)',
  accentBackgroundPrimaryBold: primitives.blue57,
  accentBackgroundPrimarySubtle: primitives.blue98,
  accentBackgroundPrimaryDisabled: 'rgba(223, 239, 254, 0.75)',
  backgroundInversePrimary: primitives.neutral18,
  backgroundInverseSecondary: primitives.neutral27,
  backgroundInverseStatelayerHover: 'rgba(236, 236, 236, 0.15)',
  backgroundInverseStatelayerPressed: 'rgba(236, 236, 236, 0.2)',
  backgroundMaterialPrimary: 'rgba(255, 255, 255, 0.82)',
  backgroundMaterialSecondary: 'rgba(255, 255, 255, 0.96)',
  backgroundMaterialTertiary: 'rgba(252, 252, 252, 0.98)',
  backgroundOverlayArt: 'rgba(255, 255, 255, 0)',
  backgroundStatelayerHover: 'rgba(17, 17, 17, 0.06)',
  backgroundStatelayerPressed: 'rgba(17, 17, 17, 0.1)',
  contentPrimary: primitives.neutral18,
  contentSecondary: primitives.neutral44,
  contentTertiary: primitives.neutral53,
  contentDisabled: primitives.neutral83,
  contentAlwaysDark: primitives.neutral18,
  contentAlwaysLight: primitives.neutral96,
  errorContentPrimary: primitives.red53,
  errorContentOnbold: primitives.red99,
  errorContentOnsubtle: primitives.red48,
  errorContentDisabled: primitives.red79,
  errorContentOninverse: primitives.red83,
  warningContentPrimary: primitives.orange53,
  warningContentOnbold: primitives.orange15,
  warningContentOnsubtle: primitives.orange48,
  warningContentDisabled: primitives.orange79,
  warningContentOninverse: primitives.orange83,
  successContentPrimary: primitives.green48,
  successContentOnbold: primitives.green99,
  successContentOnsubtle: primitives.green40,
  successContentDisabled: primitives.green79,
  successContentOninverse: primitives.green83,
  infoContentPrimary: primitives.neutral53,
  infoContentOnbold: primitives.neutral96,
  infoContentOnsubtle: primitives.neutral40,
  infoContentDisabled: primitives.neutral79,
  infoContentOninverse: primitives.neutral83,
  accentContentPrimary: primitives.blue53,
  accentContentPrimaryOnbold: primitives.blue100,
  accentContentPrimaryOnsubtle: primitives.blue40,
  accentContentPrimaryDisabled: primitives.blue79,
  contentInversePrimary: primitives.neutral99,
  contentInverseSecondary: primitives.neutral87,
  contentInverseTertiary: primitives.neutral74,
  contentLegal: primitives.blue53,
  accentContentOngradient: primitives.neutral100,
  borderAccessible: primitives.neutral61,
  borderBold: primitives.neutral18,
  borderSubtle: 'rgba(196, 196, 196, 0.65)',
  accentBorderPrimaryBold: primitives.blue57,
  accentBorderPrimarySubtle: 'rgba(175, 215, 253, 0.7)',
  accentBorderPrimaryAccessible: primitives.blue57,
  errorBorderBold: primitives.red57,
  errorBorderSubtle: 'rgba(254, 172, 156, 0.7)',
  errorBorderAccessible: primitives.red61,
  warningBorderBold: primitives.orange74,
  warningBorderSubtle: 'rgba(255, 185, 132, 0.7)',
  warningBorderAccessible: primitives.orange61,
  successBorderBold: primitives.green70,
  successBorderSubtle: 'rgba(117, 225, 144, 0.7)',
  successBorderAccessible: primitives.green57,
  infoBorderBold: primitives.neutral18,
  infoBorderSubtle: 'rgba(196, 196, 196, 0.7)',
  infoBorderAccessible: primitives.neutral61,
  contentGreenMaterialOnbold: primitives.neutral100,
  borderInverseBold: primitives.neutral96,
  contentRedMaterialOnbold: primitives.neutral100,
  borderInverseSubtle: 'rgba(71, 71, 71, 0.7)',
  contentOrangeMaterialOnbold: primitives.neutral0,
  borderInverseAccessible: primitives.neutral57,
  borderMaterialPrimary: 'rgba(255, 255, 255, 0.4)',
  contentYellowMaterialOnbold: primitives.neutral0,
  borderMaterialSecondary: primitives.neutral100,
  contentBlueMaterialOnbold: primitives.neutral100,
  borderMaterialTertiary: primitives.neutral100,
  accentGradientStop1: primitives.gradientBlue35,
  contentCrimsonMaterialOnbold: primitives.neutral100,
  accentGradientStop2: primitives.gradientBlue48,
  accentGradientStop3: primitives.gradientBlue66,
  gradientScrimStop1: 'rgba(17, 17, 17, 0.06)',
  gradientScrimStop2: 'rgba(17, 17, 17, 0.16)',
  gradientScrimStop3: 'rgba(0, 0, 0, 0.54)',
  redBackgroundMaterialBold: 'linear-gradient(to top left, #F43B00 0%, #E42500 100%)',
  orangeBackgroundMaterialBold: 'linear-gradient(to top left, #FC993C 0%, #FB762E 100%)',
  yellowBackgroundMaterialBold: 'linear-gradient(to top left, #F7E431 0%, #F1D223 100%)',
  greenBackgroundMaterialBold: 'linear-gradient(to top left, #0CA555 0%, #098042 100%)',
  blueBackgroundMaterialBold: 'linear-gradient(to top left, #1697E7 0%, #1175DD 100%)',
  crimsonBackgroundMaterialBold: 'linear-gradient(to top left, #E0336C 0%, #D32753 100%)',
  backgroundScrim: 'linear-gradient(180deg, rgba(17, 17, 17, 0.06) 0%, rgba(17, 17, 17, 0.16) 30%, rgba(0, 0, 0, 0.54) 65%)'
});

/*
 * Semantic color tokens v2, dark mode
 */
export const semanticColorTokensV2Dark = (primitives: PrimitivesParam) => ({
  backgroundBase: primitives.neutral18,
  backgroundPrimary: primitives.neutral23,
  backgroundSecondary: primitives.neutral27,
  backgroundTertiary: primitives.neutral35,
  backgroundDisabled: 'rgba(71, 71, 71, 0.6)',
  backgroundAlwaysDark: primitives.neutral27,
  backgroundAlwaysLight: primitives.neutral91,
  backgroundTrack: 'rgba(95, 95, 95, 0.2)',
  errorBackgroundBold: primitives.red53,
  errorBackgroundSubtle: primitives.red23,
  errorBackgroundDisabled: 'rgba(78, 6, 0, 0.75)',
  errorBackgroundStatelayerHover: 'rgba(58, 5, 1, 0.2)',
  errorBackgroundStatelayerPressed: 'rgba(58, 5, 1, 0.35)',
  warningBackgroundBold: primitives.orange70,
  warningBackgroundSubtle: primitives.orange27,
  warningBackgroundDisabled: 'rgba(80, 32, 2, 0.8)',
  successBackgroundBold: primitives.green66,
  successBackgroundSubtle: primitives.green27,
  successBackgroundDisabled: 'rgba(1, 60, 20, 0.75)',
  infoBackgroundBold: primitives.neutral91,
  infoBackgroundSubtle: primitives.neutral35,
  infoBackgroundDisabled: 'rgba(71, 71, 71, 0.75)',
  accentBackgroundPrimaryBold: primitives.blue66,
  accentBackgroundPrimarySubtle: primitives.blue23,
  accentBackgroundPrimaryDisabled: 'rgba(2, 38, 79, 0.75)',
  backgroundInversePrimary: primitives.neutral91,
  backgroundInverseSecondary: primitives.neutral87,
  backgroundInverseStatelayerHover: 'rgba(17, 17, 17, 0.15)',
  backgroundInverseStatelayerPressed: 'rgba(17, 17, 17, 0.2)',
  backgroundMaterialPrimary: 'rgba(39, 39, 39, 0.9)',
  backgroundMaterialSecondary: 'rgba(39, 39, 39, 0.96)',
  backgroundMaterialTertiary: 'rgba(39, 39, 39, 0.98)',
  backgroundOverlayArt: 'rgba(0, 0, 0, 0.16)',
  backgroundStatelayerHover: 'rgba(236, 236, 236, 0.1)',
  backgroundStatelayerPressed: 'rgba(236, 236, 236, 0.15)',
  contentPrimary: primitives.neutral96,
  contentSecondary: primitives.neutral87,
  contentTertiary: primitives.neutral74,
  contentDisabled: primitives.neutral44,
  contentAlwaysDark: primitives.neutral18,
  contentAlwaysLight: primitives.neutral96,
  errorContentPrimary: primitives.red79,
  errorContentOnbold: primitives.red99,
  errorContentOnsubtle: primitives.red87,
  errorContentDisabled: primitives.red44,
  errorContentOninverse: primitives.red35,
  warningContentPrimary: primitives.orange74,
  warningContentOnbold: primitives.orange15,
  warningContentOnsubtle: primitives.orange91,
  warningContentDisabled: primitives.orange53,
  warningContentOninverse: primitives.orange35,
  successContentPrimary: primitives.green74,
  successContentOnbold: primitives.green15,
  successContentOnsubtle: primitives.green91,
  successContentDisabled: primitives.green48,
  successContentOninverse: primitives.green35,
  infoContentPrimary: primitives.neutral74,
  infoContentOnbold: primitives.neutral18,
  infoContentOnsubtle: primitives.neutral91,
  infoContentDisabled: primitives.neutral53,
  infoContentOninverse: primitives.neutral35,
  accentContentPrimary: primitives.blue74,
  accentContentPrimaryOnbold: primitives.blue0,
  accentContentPrimaryOnsubtle: primitives.blue91,
  accentContentPrimaryDisabled: primitives.blue48,
  contentInversePrimary: primitives.neutral18,
  contentInverseSecondary: primitives.neutral27,
  contentInverseTertiary: primitives.neutral40,
  contentLegal: primitives.blue74,
  accentContentOngradient: primitives.neutral100,
  borderAccessible: primitives.neutral66,
  borderBold: primitives.neutral96,
  borderSubtle: 'rgba(107, 107, 107, 0.65)',
  accentBorderPrimaryBold: primitives.blue74,
  accentBorderPrimarySubtle: 'rgba(17, 117, 221, 0.3)',
  accentBorderPrimaryAccessible: primitives.blue74,
  errorBorderBold: primitives.red70,
  errorBorderSubtle: 'rgba(243, 56, 27, 0.3)',
  errorBorderAccessible: primitives.red66,
  warningBorderBold: primitives.orange74,
  warningBorderSubtle: 'rgba(172, 92, 16, 0.3)',
  warningBorderAccessible: primitives.orange66,
  successBorderBold: primitives.green70,
  successBorderSubtle: 'rgba(23, 144, 78, 0.3)',
  successBorderAccessible: primitives.green66,
  infoBorderBold: primitives.neutral96,
  infoBorderSubtle: 'rgba(119, 119, 119, 0.7)',
  infoBorderAccessible: primitives.neutral66,
  contentGreenMaterialOnbold: primitives.neutral100,
  borderInverseBold: primitives.neutral18,
  contentRedMaterialOnbold: primitives.neutral100,
  borderInverseSubtle: 'rgba(224, 224, 224, 0.7)',
  contentOrangeMaterialOnbold: primitives.neutral0,
  borderInverseAccessible: primitives.neutral53,
  borderMaterialPrimary: 'rgba(236, 236, 236, 0)',
  contentYellowMaterialOnbold: primitives.neutral0,
  borderMaterialSecondary: 'rgba(255, 255, 255, 0)',
  contentBlueMaterialOnbold: primitives.neutral100,
  borderMaterialTertiary: 'rgba(236, 236, 236, 0)',
  accentGradientStop1: primitives.gradientBlue35,
  contentCrimsonMaterialOnbold: primitives.neutral100,
  accentGradientStop2: primitives.gradientBlue48,
  accentGradientStop3: primitives.gradientBlue66,
  gradientScrimStop1: 'rgba(17, 17, 17, 0.72)',
  gradientScrimStop2: 'rgba(10, 10, 10, 0.54)',
  gradientScrimStop3: 'rgba(10, 10, 10, 0.54)',
  redBackgroundMaterialBold: 'linear-gradient(to top left, #F43B00 0%, #E42500 100%)',
  orangeBackgroundMaterialBold: 'linear-gradient(to top left, #FC993C 0%, #FB762E 100%)',
  yellowBackgroundMaterialBold: 'linear-gradient(to top left, #F7E431 0%, #F1D223 100%)',
  greenBackgroundMaterialBold: 'linear-gradient(to top left, #0CA555 0%, #098042 100%)',
  blueBackgroundMaterialBold: 'linear-gradient(to top left, #1697E7 0%, #1175DD 100%)',
  crimsonBackgroundMaterialBold: 'linear-gradient(to top left, #E0336C 0%, #D32753 100%)',
  backgroundScrim: 'linear-gradient(180deg, rgba(17, 17, 17, 0.72) 0%, rgba(10, 10, 10, 0.54) 30%, rgba(10, 10, 10, 0.54) 100%)'
});

/*
 * Semantic color tokens v2, dark elevated mode
 */
export const semanticColorTokensV2DarkElevated = (primitives: PrimitivesParam) => ({
  backgroundBase: primitives.neutral27,
  backgroundPrimary: primitives.neutral31,
  backgroundSecondary: primitives.neutral35,
  backgroundTertiary: primitives.neutral44,
  backgroundDisabled: 'rgba(95, 95, 95, 0.6)',
  backgroundAlwaysDark: primitives.neutral35,
  backgroundAlwaysLight: primitives.neutral98,
  backgroundTrack: 'rgba(95, 95, 95, 0.2)',
  errorBackgroundBold: primitives.red57,
  errorBackgroundSubtle: primitives.red27,
  errorBackgroundDisabled: 'rgba(114, 13, 0, 0.75)',
  errorBackgroundStatelayerHover: 'rgba(58, 5, 1, 0.2)',
  errorBackgroundStatelayerPressed: 'rgba(58, 5, 1, 0.35)',
  warningBackgroundBold: primitives.orange79,
  warningBackgroundSubtle: primitives.orange35,
  warningBackgroundDisabled: 'rgba(110, 50, 2, 0.8)',
  successBackgroundBold: primitives.green74,
  successBackgroundSubtle: primitives.green35,
  successBackgroundDisabled: 'rgba(9, 86, 39, 0.75)',
  infoBackgroundBold: primitives.neutral98,
  infoBackgroundSubtle: primitives.neutral44,
  infoBackgroundDisabled: 'rgba(95, 95, 95, 0.75)',
  accentBackgroundPrimaryBold: primitives.blue74,
  accentBackgroundPrimarySubtle: primitives.blue31,
  accentBackgroundPrimaryDisabled: 'rgba(3, 58, 116, 0.75)',
  backgroundInversePrimary: primitives.neutral98,
  backgroundInverseSecondary: primitives.neutral96,
  backgroundInverseStatelayerHover: 'rgba(17, 17, 17, 0.15)',
  backgroundInverseStatelayerPressed: 'rgba(17, 17, 17, 0.2)',
  backgroundMaterialPrimary: 'rgba(39, 39, 39, 0.9)',
  backgroundMaterialSecondary: 'rgba(39, 39, 39, 0.96)',
  backgroundMaterialTertiary: 'rgba(39, 39, 39, 0.98)',
  backgroundOverlayArt: 'rgba(0, 0, 0, 0.16)',
  backgroundStatelayerHover: 'rgba(236, 236, 236, 0.1)',
  backgroundStatelayerPressed: 'rgba(236, 236, 236, 0.15)',
  contentPrimary: primitives.neutral99,
  contentSecondary: primitives.neutral96,
  contentTertiary: primitives.neutral83,
  contentDisabled: primitives.neutral53,
  contentAlwaysDark: primitives.neutral27,
  contentAlwaysLight: primitives.neutral99,
  errorContentPrimary: primitives.red87,
  errorContentOnbold: primitives.red99,
  errorContentOnsubtle: primitives.red96,
  errorContentDisabled: primitives.red53,
  errorContentOninverse: primitives.red44,
  warningContentPrimary: primitives.orange83,
  warningContentOnbold: primitives.orange23,
  warningContentOnsubtle: primitives.orange98,
  warningContentDisabled: primitives.orange61,
  warningContentOninverse: primitives.orange44,
  successContentPrimary: primitives.green83,
  successContentOnbold: primitives.green23,
  successContentOnsubtle: primitives.green98,
  successContentDisabled: primitives.green57,
  successContentOninverse: primitives.green44,
  infoContentPrimary: primitives.neutral83,
  infoContentOnbold: primitives.neutral27,
  infoContentOnsubtle: primitives.neutral98,
  infoContentDisabled: primitives.neutral61,
  infoContentOninverse: primitives.neutral44,
  accentContentPrimary: primitives.blue83,
  accentContentPrimaryOnbold: primitives.blue18,
  accentContentPrimaryOnsubtle: primitives.blue98,
  accentContentPrimaryDisabled: primitives.blue57,
  contentInversePrimary: primitives.neutral27,
  contentInverseSecondary: primitives.neutral35,
  contentInverseTertiary: primitives.neutral48,
  contentLegal: primitives.blue83,
  accentContentOngradient: primitives.neutral100,
  borderAccessible: primitives.neutral74,
  borderBold: primitives.neutral99,
  borderSubtle: 'rgba(131, 131, 131, 0.65)',
  accentBorderPrimaryBold: primitives.blue83,
  accentBorderPrimarySubtle: 'rgba(51, 163, 252, 0.3)',
  accentBorderPrimaryAccessible: primitives.blue83,
  errorBorderBold: primitives.red79,
  errorBorderSubtle: 'rgba(252, 79, 52, 0.3)',
  errorBorderAccessible: primitives.red74,
  warningBorderBold: primitives.orange83,
  warningBorderSubtle: 'rgba(212, 118, 20, 0.3)',
  warningBorderAccessible: primitives.orange74,
  successBorderBold: primitives.green79,
  successBorderSubtle: 'rgba(29, 176, 97, 0.3)',
  successBorderAccessible: primitives.green74,
  infoBorderBold: primitives.neutral99,
  infoBorderSubtle: 'rgba(144, 144, 144, 0.7)',
  infoBorderAccessible: primitives.neutral74,
  contentGreenMaterialOnbold: primitives.neutral100,
  borderInverseBold: primitives.neutral27,
  contentRedMaterialOnbold: primitives.neutral100,
  borderInverseSubtle: 'rgba(252, 252, 252, 0.7)',
  contentOrangeMaterialOnbold: primitives.neutral0,
  borderInverseAccessible: primitives.neutral61,
  borderMaterialPrimary: 'rgba(236, 236, 236, 0)',
  contentYellowMaterialOnbold: primitives.neutral0,
  borderMaterialSecondary: 'rgba(255, 255, 255, 0)',
  contentBlueMaterialOnbold: primitives.neutral100,
  borderMaterialTertiary: 'rgba(236, 236, 236, 0)',
  accentGradientStop1: primitives.gradientBlue35,
  contentCrimsonMaterialOnbold: primitives.neutral100,
  accentGradientStop2: primitives.gradientBlue48,
  accentGradientStop3: primitives.gradientBlue66,
  gradientScrimStop1: 'rgba(17, 17, 17, 0.72)',
  gradientScrimStop2: 'rgba(10, 10, 10, 0.54)',
  gradientScrimStop3: 'rgba(10, 10, 10, 0.54)',
  redBackgroundMaterialBold: 'linear-gradient(to top left, #F43B00 0%, #E42500 100%)',
  orangeBackgroundMaterialBold: 'linear-gradient(to top left, #FC993C 0%, #FB762E 100%)',
  yellowBackgroundMaterialBold: 'linear-gradient(to top left, #F7E431 0%, #F1D223 100%)',
  greenBackgroundMaterialBold: 'linear-gradient(to top left, #0CA555 0%, #098042 100%)',
  blueBackgroundMaterialBold: 'linear-gradient(to top left, #1697E7 0%, #1175DD 100%)',
  crimsonBackgroundMaterialBold: 'linear-gradient(to top left, #E0336C 0%, #D32753 100%)',
  backgroundScrim: 'linear-gradient(180deg, rgba(17, 17, 17, 0.72) 0%, rgba(10, 10, 10, 0.54) 30%, rgba(10, 10, 10, 0.54) 100%)'
});

/*
 * Product extension: offers, light mode (overrides only)
 */
export const semanticColorTokensV2OffersLight = (primitives: PrimitivesParam) => ({
  accentBackgroundPrimaryBold: primitives.red57,
  accentContentPrimaryOnsubtle: primitives.red40,
  accentBackgroundPrimarySubtle: primitives.red91,
  accentBackgroundPrimaryDisabled: 'rgba(254, 230, 225, 0.75)',
  accentContentPrimary: primitives.red57,
  accentGradientStop3: primitives.red66,
  accentContentPrimaryDisabled: primitives.red79,
  accentGradientStop2: primitives.red48,
  accentGradientStop1: primitives.red35,
  accentBorderPrimarySubtle: 'rgba(254, 172, 156, 0.7)',
  accentBorderPrimaryAccessible: primitives.red57,
  accentContentPrimaryOnbold: primitives.red100,
  accentBorderPrimaryBold: primitives.red57
});

/*
 * Product extension: offers, dark mode (overrides only)
 */
export const semanticColorTokensV2OffersDark = (primitives: PrimitivesParam) => ({
  accentBackgroundPrimaryBold: primitives.red57,
  accentContentPrimaryOnsubtle: primitives.red91,
  accentBackgroundPrimarySubtle: primitives.red40,
  accentBackgroundPrimaryDisabled: 'rgba(78, 6, 0, 0.75)',
  accentContentPrimary: primitives.red79,
  accentGradientStop3: primitives.red66,
  accentContentPrimaryDisabled: primitives.red44,
  accentGradientStop2: primitives.red48,
  accentGradientStop1: primitives.red35,
  accentBorderPrimarySubtle: 'rgba(228, 37, 0, 0.7)',
  accentBorderPrimaryAccessible: primitives.red79,
  accentContentPrimaryOnbold: primitives.red100,
  accentBorderPrimaryBold: primitives.red74
});

/*
 * Product extension: offers, dark elevated mode (overrides only)
 */
export const semanticColorTokensV2OffersDarkElevated = (primitives: PrimitivesParam) => ({
  accentBackgroundPrimaryDisabled: 'rgba(114, 13, 0, 0.75)',
  accentContentPrimaryDisabled: primitives.red53
});

/*
 * Product extension: membership, light mode (overrides only)
 */
export const semanticColorTokensV2MembershipLight = (primitives: PrimitivesParam) => ({
  accentBorderPrimaryBold: primitives.membership57,
  accentBackgroundPrimaryBold: primitives.membership57,
  accentContentPrimaryOnbold: primitives.neutral100,
  accentBackgroundPrimaryDisabled: 'rgba(254, 234, 200, 0.75)',
  accentContentPrimary: primitives.membership57,
  accentGradientStop3: primitives.membership48,
  accentContentPrimaryDisabled: primitives.membership79,
  accentBackgroundPrimarySubtle: primitives.membership98,
  accentContentPrimaryOnsubtle: primitives.membership57,
  accentGradientStop2: primitives.membership57,
  accentGradientStop1: primitives.membership61,
  accentBorderPrimarySubtle: 'rgba(254, 202, 135, 0.87)',
  accentBorderPrimaryAccessible: primitives.membership57
});

/*
 * Product extension: membership, dark mode (overrides only)
 */
export const semanticColorTokensV2MembershipDark = (primitives: PrimitivesParam) => ({
  accentBorderPrimaryBold: primitives.membership74,
  accentBackgroundPrimaryBold: primitives.membership74,
  accentContentPrimaryOnbold: primitives.neutral0,
  accentBackgroundPrimaryDisabled: 'rgba(56, 32, 1, 0.75)',
  accentContentPrimary: primitives.membership74,
  accentGradientStop3: primitives.membership48,
  accentContentPrimaryDisabled: primitives.membership40,
  accentBackgroundPrimarySubtle: primitives.membership31,
  accentContentPrimaryOnsubtle: primitives.membership74,
  accentGradientStop2: primitives.membership57,
  accentGradientStop1: primitives.membership61,
  accentBorderPrimarySubtle: 'rgba(159, 100, 2, 0.3)',
  accentBorderPrimaryAccessible: primitives.membership74
});

/*
 * Product extension: membership, dark elevated mode (overrides only)
 */
export const semanticColorTokensV2MembershipDarkElevated = (primitives: PrimitivesParam) => ({
  accentBorderPrimaryBold: primitives.membership83,
  accentBackgroundPrimaryBold: primitives.membership83,
  accentContentPrimaryOnbold: primitives.neutral0,
  accentBackgroundPrimaryDisabled: 'rgba(83, 50, 4, 0.35)',
  accentContentPrimary: primitives.membership83,
  accentGradientStop3: primitives.membership48,
  accentContentPrimaryDisabled: primitives.membership48,
  accentBackgroundPrimarySubtle: primitives.membership40,
  accentGradientStop2: primitives.membership57,
  accentGradientStop1: primitives.membership61,
  accentBorderPrimarySubtle: 'rgba(204, 142, 64, 0.3)',
  accentBorderPrimaryAccessible: primitives.membership83
});

/*
 * Product extension: ai, light mode (overrides only)
 */
export const semanticColorTokensV2AiLight = (primitives: PrimitivesParam) => ({
  accentBorderPrimarySubtle: 'rgba(191, 187, 254, 0.7)',
  accentContentPrimaryOnsubtle: primitives.indigo40,
  accentBackgroundPrimarySubtle: primitives.indigo96,
  accentContentPrimary: primitives.indigo48,
  accentBackgroundPrimaryDisabled: 'rgba(235, 234, 254, 0.75)',
  accentContentPrimaryOnbold: primitives.indigo100,
  accentBorderPrimaryBold: primitives.indigo57,
  accentBorderPrimaryAccessible: primitives.indigo53,
  accentContentPrimaryDisabled: primitives.indigo74,
  accentGradientStop3: primitives.indigo66,
  accentBackgroundPrimaryBold: primitives.indigo53,
  accentGradientStop1: primitives.indigo35,
  accentGradientStop2: primitives.indigo48
});

/*
 * Product extension: ai, dark mode (overrides only)
 */
export const semanticColorTokensV2AiDark = (primitives: PrimitivesParam) => ({
  accentBorderPrimarySubtle: 'rgba(116, 95, 218, 0.7)',
  accentContentPrimaryOnsubtle: primitives.indigo91,
  accentBackgroundPrimarySubtle: primitives.indigo31,
  accentContentPrimary: primitives.indigo74,
  accentBackgroundPrimaryDisabled: 'rgba(70, 47, 151, 0.75)',
  accentContentPrimaryOnbold: primitives.indigo0,
  accentBorderPrimaryBold: primitives.indigo57,
  accentBorderPrimaryAccessible: primitives.indigo74,
  accentContentPrimaryDisabled: primitives.indigo57,
  accentGradientStop3: primitives.indigo66,
  accentBackgroundPrimaryBold: primitives.indigo74,
  accentGradientStop1: primitives.indigo35,
  accentGradientStop2: primitives.indigo48
});

/*
 * Product extension: ai, dark elevated mode (overrides only)
 */
export const semanticColorTokensV2AiDarkElevated = (primitives: PrimitivesParam) => ({
  accentBackgroundPrimaryDisabled: 'rgba(93, 68, 189, 0.75)',
  accentContentPrimaryDisabled: primitives.indigo66
});

/*
 * Product extension: eats, light mode (overrides only)
 */
export const semanticColorTokensV2EatsLight = (primitives: PrimitivesParam) => ({
  accentBorderPrimarySubtle: 'rgba(117, 225, 144, 0.7)',
  accentBackgroundPrimarySubtle: primitives.green98,
  accentContentPrimaryOnsubtle: primitives.green40,
  accentGradientStop1: primitives.green35,
  accentGradientStop2: primitives.green48,
  accentBackgroundPrimaryBold: primitives.green53,
  accentContentPrimaryOnbold: primitives.green100,
  accentBorderPrimaryBold: primitives.green57,
  accentBorderPrimaryAccessible: primitives.green53,
  accentContentPrimaryDisabled: primitives.green74,
  accentGradientStop3: primitives.green66,
  accentBackgroundPrimaryDisabled: primitives.green98,
  accentContentPrimary: primitives.green48
});

/*
 * Product extension: eats, dark mode (overrides only)
 */
export const semanticColorTokensV2EatsDark = (primitives: PrimitivesParam) => ({
  accentBorderPrimarySubtle: 'rgba(23, 144, 78, 0.7)',
  accentBackgroundPrimarySubtle: primitives.green31,
  accentContentPrimaryOnsubtle: primitives.green91,
  accentGradientStop1: primitives.green35,
  accentGradientStop2: primitives.green48,
  accentBackgroundPrimaryBold: primitives.green70,
  accentContentPrimaryOnbold: primitives.green0,
  accentBorderPrimaryBold: primitives.green74,
  accentBorderPrimaryAccessible: primitives.green74,
  accentContentPrimaryDisabled: primitives.green57,
  accentGradientStop3: primitives.green66,
  accentBackgroundPrimaryDisabled: primitives.green35,
  accentContentPrimary: primitives.green74
});

/*
 * CSS-variable references for all v2 semantic tokens.
 *
 * Spread into a JS/Styletron theme to delegate every resolved color to the
 * CSS layer.  Control the active variant purely via HTML data attributes on
 * any ancestor element — no JS theme swap is required:
 *
 *   data-base-version-color="2"   — opt in to v2 tokens (base-colors-v2.css required)
 *   data-theme="dark"             — dark mode
 *   data-elevated="true"          — dark-elevated surface
 *   data-product="<name>"         — product accent overrides (ai, eats, offers, …)
 *
 * Product extension overrides are handled entirely by CSS selector specificity
 * in base-colors-v2.css and are intentionally absent from this object.
 */
export const semanticColorTokensV2CssVars = ({
  backgroundBase: 'var(--base-background-base)',
  backgroundPrimary: 'var(--base-background-primary)',
  backgroundSecondary: 'var(--base-background-secondary)',
  backgroundTertiary: 'var(--base-background-tertiary)',
  backgroundDisabled: 'var(--base-background-disabled)',
  backgroundAlwaysDark: 'var(--base-background-always-dark)',
  backgroundAlwaysLight: 'var(--base-background-always-light)',
  backgroundTrack: 'var(--base-background-track)',
  errorBackgroundBold: 'var(--base-error-background-bold)',
  errorBackgroundSubtle: 'var(--base-error-background-subtle)',
  errorBackgroundDisabled: 'var(--base-error-background-disabled)',
  errorBackgroundStatelayerHover: 'var(--base-error-background-statelayer-hover)',
  errorBackgroundStatelayerPressed: 'var(--base-error-background-statelayer-pressed)',
  warningBackgroundBold: 'var(--base-warning-background-bold)',
  warningBackgroundSubtle: 'var(--base-warning-background-subtle)',
  warningBackgroundDisabled: 'var(--base-warning-background-disabled)',
  successBackgroundBold: 'var(--base-success-background-bold)',
  successBackgroundSubtle: 'var(--base-success-background-subtle)',
  successBackgroundDisabled: 'var(--base-success-background-disabled)',
  infoBackgroundBold: 'var(--base-info-background-bold)',
  infoBackgroundSubtle: 'var(--base-info-background-subtle)',
  infoBackgroundDisabled: 'var(--base-info-background-disabled)',
  accentBackgroundPrimaryBold: 'var(--base-accent-background-primary-bold)',
  accentBackgroundPrimarySubtle: 'var(--base-accent-background-primary-subtle)',
  accentBackgroundPrimaryDisabled: 'var(--base-accent-background-primary-disabled)',
  backgroundInversePrimary: 'var(--base-background-inverse-primary)',
  backgroundInverseSecondary: 'var(--base-background-inverse-secondary)',
  backgroundInverseStatelayerHover: 'var(--base-background-inverse-statelayer-hover)',
  backgroundInverseStatelayerPressed: 'var(--base-background-inverse-statelayer-pressed)',
  backgroundMaterialPrimary: 'var(--base-background-material-primary)',
  backgroundMaterialSecondary: 'var(--base-background-material-secondary)',
  backgroundMaterialTertiary: 'var(--base-background-material-tertiary)',
  backgroundOverlayArt: 'var(--base-background-overlay-art)',
  backgroundStatelayerHover: 'var(--base-background-statelayer-hover)',
  backgroundStatelayerPressed: 'var(--base-background-statelayer-pressed)',
  contentPrimary: 'var(--base-content-primary)',
  contentSecondary: 'var(--base-content-secondary)',
  contentTertiary: 'var(--base-content-tertiary)',
  contentDisabled: 'var(--base-content-disabled)',
  contentAlwaysDark: 'var(--base-content-always-dark)',
  contentAlwaysLight: 'var(--base-content-always-light)',
  errorContentPrimary: 'var(--base-error-content-primary)',
  errorContentOnbold: 'var(--base-error-content-onbold)',
  errorContentOnsubtle: 'var(--base-error-content-onsubtle)',
  errorContentDisabled: 'var(--base-error-content-disabled)',
  errorContentOninverse: 'var(--base-error-content-oninverse)',
  warningContentPrimary: 'var(--base-warning-content-primary)',
  warningContentOnbold: 'var(--base-warning-content-onbold)',
  warningContentOnsubtle: 'var(--base-warning-content-onsubtle)',
  warningContentDisabled: 'var(--base-warning-content-disabled)',
  warningContentOninverse: 'var(--base-warning-content-oninverse)',
  successContentPrimary: 'var(--base-success-content-primary)',
  successContentOnbold: 'var(--base-success-content-onbold)',
  successContentOnsubtle: 'var(--base-success-content-onsubtle)',
  successContentDisabled: 'var(--base-success-content-disabled)',
  successContentOninverse: 'var(--base-success-content-oninverse)',
  infoContentPrimary: 'var(--base-info-content-primary)',
  infoContentOnbold: 'var(--base-info-content-onbold)',
  infoContentOnsubtle: 'var(--base-info-content-onsubtle)',
  infoContentDisabled: 'var(--base-info-content-disabled)',
  infoContentOninverse: 'var(--base-info-content-oninverse)',
  accentContentPrimary: 'var(--base-accent-content-primary)',
  accentContentPrimaryOnbold: 'var(--base-accent-content-primary-onbold)',
  accentContentPrimaryOnsubtle: 'var(--base-accent-content-primary-onsubtle)',
  accentContentPrimaryDisabled: 'var(--base-accent-content-primary-disabled)',
  contentInversePrimary: 'var(--base-content-inverse-primary)',
  contentInverseSecondary: 'var(--base-content-inverse-secondary)',
  contentInverseTertiary: 'var(--base-content-inverse-tertiary)',
  contentLegal: 'var(--base-content-legal)',
  accentContentOngradient: 'var(--base-accent-content-ongradient)',
  borderAccessible: 'var(--base-border-accessible)',
  borderBold: 'var(--base-border-bold)',
  borderSubtle: 'var(--base-border-subtle)',
  accentBorderPrimaryBold: 'var(--base-accent-border-primary-bold)',
  accentBorderPrimarySubtle: 'var(--base-accent-border-primary-subtle)',
  accentBorderPrimaryAccessible: 'var(--base-accent-border-primary-accessible)',
  errorBorderBold: 'var(--base-error-border-bold)',
  errorBorderSubtle: 'var(--base-error-border-subtle)',
  errorBorderAccessible: 'var(--base-error-border-accessible)',
  warningBorderBold: 'var(--base-warning-border-bold)',
  warningBorderSubtle: 'var(--base-warning-border-subtle)',
  warningBorderAccessible: 'var(--base-warning-border-accessible)',
  successBorderBold: 'var(--base-success-border-bold)',
  successBorderSubtle: 'var(--base-success-border-subtle)',
  successBorderAccessible: 'var(--base-success-border-accessible)',
  infoBorderBold: 'var(--base-info-border-bold)',
  infoBorderSubtle: 'var(--base-info-border-subtle)',
  infoBorderAccessible: 'var(--base-info-border-accessible)',
  contentGreenMaterialOnbold: 'var(--base-content-green-material-onbold)',
  borderInverseBold: 'var(--base-border-inverse-bold)',
  contentRedMaterialOnbold: 'var(--base-content-red-material-onbold)',
  borderInverseSubtle: 'var(--base-border-inverse-subtle)',
  contentOrangeMaterialOnbold: 'var(--base-content-orange-material-onbold)',
  borderInverseAccessible: 'var(--base-border-inverse-accessible)',
  borderMaterialPrimary: 'var(--base-border-material-primary)',
  contentYellowMaterialOnbold: 'var(--base-content-yellow-material-onbold)',
  borderMaterialSecondary: 'var(--base-border-material-secondary)',
  contentBlueMaterialOnbold: 'var(--base-content-blue-material-onbold)',
  borderMaterialTertiary: 'var(--base-border-material-tertiary)',
  accentGradientStop1: 'var(--base-accent-gradient-stop-1)',
  contentCrimsonMaterialOnbold: 'var(--base-content-crimson-material-onbold)',
  accentGradientStop2: 'var(--base-accent-gradient-stop-2)',
  accentGradientStop3: 'var(--base-accent-gradient-stop-3)',
  gradientScrimStop1: 'var(--base-gradient-scrim-stop-1)',
  gradientScrimStop2: 'var(--base-gradient-scrim-stop-2)',
  gradientScrimStop3: 'var(--base-gradient-scrim-stop-3)',
  redBackgroundMaterialBold: 'var(--base-red-background-material-bold)',
  orangeBackgroundMaterialBold: 'var(--base-orange-background-material-bold)',
  yellowBackgroundMaterialBold: 'var(--base-yellow-background-material-bold)',
  greenBackgroundMaterialBold: 'var(--base-green-background-material-bold)',
  blueBackgroundMaterialBold: 'var(--base-blue-background-material-bold)',
  crimsonBackgroundMaterialBold: 'var(--base-crimson-background-material-bold)',
  backgroundScrim: 'var(--base-background-scrim)'
} as const);
export type SemanticColorTokensV2CssVarsType = typeof semanticColorTokensV2CssVars;

/*
 * CSS-variable references for all v2 primitive color tokens.
 *
 * These resolve from :root custom properties in base-colors-v2.css and are
 * always available — no data-base-version-color attribute is required.
 * Safe to spread into a JS/Styletron theme as a direct replacement for
 * the raw-hex primitiveColorTokensV2 object.
 */
export const primitiveColorTokensV2CssVars = ({
  amber0: 'var(--base-amber-0)',
  amber15: 'var(--base-amber-15)',
  amber18: 'var(--base-amber-18)',
  amber23: 'var(--base-amber-23)',
  amber27: 'var(--base-amber-27)',
  amber31: 'var(--base-amber-31)',
  amber35: 'var(--base-amber-35)',
  amber40: 'var(--base-amber-40)',
  amber44: 'var(--base-amber-44)',
  amber48: 'var(--base-amber-48)',
  amber53: 'var(--base-amber-53)',
  amber57: 'var(--base-amber-57)',
  amber61: 'var(--base-amber-61)',
  amber66: 'var(--base-amber-66)',
  amber70: 'var(--base-amber-70)',
  amber74: 'var(--base-amber-74)',
  amber79: 'var(--base-amber-79)',
  amber83: 'var(--base-amber-83)',
  amber87: 'var(--base-amber-87)',
  amber91: 'var(--base-amber-91)',
  amber96: 'var(--base-amber-96)',
  amber98: 'var(--base-amber-98)',
  amber99: 'var(--base-amber-99)',
  amber100: 'var(--base-amber-100)',
  blue0: 'var(--base-blue-0)',
  blue15: 'var(--base-blue-15)',
  blue18: 'var(--base-blue-18)',
  blue23: 'var(--base-blue-23)',
  blue27: 'var(--base-blue-27)',
  blue31: 'var(--base-blue-31)',
  blue35: 'var(--base-blue-35)',
  blue40: 'var(--base-blue-40)',
  blue44: 'var(--base-blue-44)',
  blue48: 'var(--base-blue-48)',
  blue53: 'var(--base-blue-53)',
  blue57: 'var(--base-blue-57)',
  blue61: 'var(--base-blue-61)',
  blue66: 'var(--base-blue-66)',
  blue70: 'var(--base-blue-70)',
  blue74: 'var(--base-blue-74)',
  blue79: 'var(--base-blue-79)',
  blue83: 'var(--base-blue-83)',
  blue87: 'var(--base-blue-87)',
  blue91: 'var(--base-blue-91)',
  blue96: 'var(--base-blue-96)',
  blue98: 'var(--base-blue-98)',
  blue99: 'var(--base-blue-99)',
  blue100: 'var(--base-blue-100)',
  gradientBlue0: 'var(--base-gradient-blue-0)',
  gradientBlue15: 'var(--base-gradient-blue-15)',
  gradientBlue18: 'var(--base-gradient-blue-18)',
  gradientBlue23: 'var(--base-gradient-blue-23)',
  gradientBlue27: 'var(--base-gradient-blue-27)',
  gradientBlue31: 'var(--base-gradient-blue-31)',
  gradientBlue35: 'var(--base-gradient-blue-35)',
  gradientBlue40: 'var(--base-gradient-blue-40)',
  gradientBlue44: 'var(--base-gradient-blue-44)',
  gradientBlue48: 'var(--base-gradient-blue-48)',
  gradientBlue53: 'var(--base-gradient-blue-53)',
  gradientBlue57: 'var(--base-gradient-blue-57)',
  gradientBlue61: 'var(--base-gradient-blue-61)',
  gradientBlue66: 'var(--base-gradient-blue-66)',
  gradientBlue70: 'var(--base-gradient-blue-70)',
  gradientBlue74: 'var(--base-gradient-blue-74)',
  gradientBlue79: 'var(--base-gradient-blue-79)',
  gradientBlue83: 'var(--base-gradient-blue-83)',
  gradientBlue87: 'var(--base-gradient-blue-87)',
  gradientBlue91: 'var(--base-gradient-blue-91)',
  gradientBlue96: 'var(--base-gradient-blue-96)',
  gradientBlue98: 'var(--base-gradient-blue-98)',
  gradientBlue99: 'var(--base-gradient-blue-99)',
  gradientBlue100: 'var(--base-gradient-blue-100)',
  gradientIndigo0: 'var(--base-gradient-indigo-0)',
  gradientIndigo15: 'var(--base-gradient-indigo-15)',
  gradientIndigo18: 'var(--base-gradient-indigo-18)',
  gradientIndigo23: 'var(--base-gradient-indigo-23)',
  gradientIndigo27: 'var(--base-gradient-indigo-27)',
  gradientIndigo31: 'var(--base-gradient-indigo-31)',
  gradientIndigo35: 'var(--base-gradient-indigo-35)',
  gradientIndigo40: 'var(--base-gradient-indigo-40)',
  gradientIndigo44: 'var(--base-gradient-indigo-44)',
  gradientIndigo48: 'var(--base-gradient-indigo-48)',
  gradientIndigo53: 'var(--base-gradient-indigo-53)',
  gradientIndigo57: 'var(--base-gradient-indigo-57)',
  gradientIndigo61: 'var(--base-gradient-indigo-61)',
  gradientIndigo66: 'var(--base-gradient-indigo-66)',
  gradientIndigo70: 'var(--base-gradient-indigo-70)',
  gradientIndigo74: 'var(--base-gradient-indigo-74)',
  gradientIndigo79: 'var(--base-gradient-indigo-79)',
  gradientIndigo83: 'var(--base-gradient-indigo-83)',
  gradientIndigo87: 'var(--base-gradient-indigo-87)',
  gradientIndigo91: 'var(--base-gradient-indigo-91)',
  gradientIndigo96: 'var(--base-gradient-indigo-96)',
  gradientIndigo98: 'var(--base-gradient-indigo-98)',
  gradientIndigo99: 'var(--base-gradient-indigo-99)',
  gradientIndigo100: 'var(--base-gradient-indigo-100)',
  gradientRed0: 'var(--base-gradient-red-0)',
  gradientRed15: 'var(--base-gradient-red-15)',
  gradientRed18: 'var(--base-gradient-red-18)',
  gradientRed23: 'var(--base-gradient-red-23)',
  gradientRed27: 'var(--base-gradient-red-27)',
  gradientRed31: 'var(--base-gradient-red-31)',
  gradientRed35: 'var(--base-gradient-red-35)',
  gradientRed40: 'var(--base-gradient-red-40)',
  gradientRed44: 'var(--base-gradient-red-44)',
  gradientRed48: 'var(--base-gradient-red-48)',
  gradientRed53: 'var(--base-gradient-red-53)',
  gradientRed57: 'var(--base-gradient-red-57)',
  gradientRed61: 'var(--base-gradient-red-61)',
  gradientRed66: 'var(--base-gradient-red-66)',
  gradientRed70: 'var(--base-gradient-red-70)',
  gradientRed74: 'var(--base-gradient-red-74)',
  gradientRed79: 'var(--base-gradient-red-79)',
  gradientRed83: 'var(--base-gradient-red-83)',
  gradientRed87: 'var(--base-gradient-red-87)',
  gradientRed91: 'var(--base-gradient-red-91)',
  gradientRed96: 'var(--base-gradient-red-96)',
  gradientRed98: 'var(--base-gradient-red-98)',
  gradientRed99: 'var(--base-gradient-red-99)',
  gradientRed100: 'var(--base-gradient-red-100)',
  green0: 'var(--base-green-0)',
  green15: 'var(--base-green-15)',
  green18: 'var(--base-green-18)',
  green23: 'var(--base-green-23)',
  green27: 'var(--base-green-27)',
  green31: 'var(--base-green-31)',
  green35: 'var(--base-green-35)',
  green40: 'var(--base-green-40)',
  green44: 'var(--base-green-44)',
  green48: 'var(--base-green-48)',
  green53: 'var(--base-green-53)',
  green57: 'var(--base-green-57)',
  green61: 'var(--base-green-61)',
  green66: 'var(--base-green-66)',
  green70: 'var(--base-green-70)',
  green74: 'var(--base-green-74)',
  green79: 'var(--base-green-79)',
  green83: 'var(--base-green-83)',
  green87: 'var(--base-green-87)',
  green91: 'var(--base-green-91)',
  green96: 'var(--base-green-96)',
  green98: 'var(--base-green-98)',
  green99: 'var(--base-green-99)',
  green100: 'var(--base-green-100)',
  indigo0: 'var(--base-indigo-0)',
  indigo15: 'var(--base-indigo-15)',
  indigo18: 'var(--base-indigo-18)',
  indigo23: 'var(--base-indigo-23)',
  indigo27: 'var(--base-indigo-27)',
  indigo31: 'var(--base-indigo-31)',
  indigo35: 'var(--base-indigo-35)',
  indigo40: 'var(--base-indigo-40)',
  indigo44: 'var(--base-indigo-44)',
  indigo48: 'var(--base-indigo-48)',
  indigo53: 'var(--base-indigo-53)',
  indigo57: 'var(--base-indigo-57)',
  indigo61: 'var(--base-indigo-61)',
  indigo66: 'var(--base-indigo-66)',
  indigo70: 'var(--base-indigo-70)',
  indigo74: 'var(--base-indigo-74)',
  indigo79: 'var(--base-indigo-79)',
  indigo83: 'var(--base-indigo-83)',
  indigo87: 'var(--base-indigo-87)',
  indigo91: 'var(--base-indigo-91)',
  indigo96: 'var(--base-indigo-96)',
  indigo98: 'var(--base-indigo-98)',
  indigo99: 'var(--base-indigo-99)',
  indigo100: 'var(--base-indigo-100)',
  lime0: 'var(--base-lime-0)',
  lime15: 'var(--base-lime-15)',
  lime18: 'var(--base-lime-18)',
  lime23: 'var(--base-lime-23)',
  lime27: 'var(--base-lime-27)',
  lime31: 'var(--base-lime-31)',
  lime35: 'var(--base-lime-35)',
  lime40: 'var(--base-lime-40)',
  lime44: 'var(--base-lime-44)',
  lime48: 'var(--base-lime-48)',
  lime53: 'var(--base-lime-53)',
  lime57: 'var(--base-lime-57)',
  lime61: 'var(--base-lime-61)',
  lime66: 'var(--base-lime-66)',
  lime70: 'var(--base-lime-70)',
  lime74: 'var(--base-lime-74)',
  lime79: 'var(--base-lime-79)',
  lime83: 'var(--base-lime-83)',
  lime87: 'var(--base-lime-87)',
  lime91: 'var(--base-lime-91)',
  lime96: 'var(--base-lime-96)',
  lime98: 'var(--base-lime-98)',
  lime99: 'var(--base-lime-99)',
  lime100: 'var(--base-lime-100)',
  magenta0: 'var(--base-magenta-0)',
  magenta15: 'var(--base-magenta-15)',
  magenta18: 'var(--base-magenta-18)',
  magenta23: 'var(--base-magenta-23)',
  magenta27: 'var(--base-magenta-27)',
  magenta31: 'var(--base-magenta-31)',
  magenta35: 'var(--base-magenta-35)',
  magenta40: 'var(--base-magenta-40)',
  magenta44: 'var(--base-magenta-44)',
  magenta48: 'var(--base-magenta-48)',
  magenta53: 'var(--base-magenta-53)',
  magenta57: 'var(--base-magenta-57)',
  magenta61: 'var(--base-magenta-61)',
  magenta66: 'var(--base-magenta-66)',
  magenta70: 'var(--base-magenta-70)',
  magenta74: 'var(--base-magenta-74)',
  magenta79: 'var(--base-magenta-79)',
  magenta83: 'var(--base-magenta-83)',
  magenta87: 'var(--base-magenta-87)',
  magenta91: 'var(--base-magenta-91)',
  magenta96: 'var(--base-magenta-96)',
  magenta98: 'var(--base-magenta-98)',
  magenta99: 'var(--base-magenta-99)',
  magenta100: 'var(--base-magenta-100)',
  membership0: 'var(--base-membership-0)',
  membership15: 'var(--base-membership-15)',
  membership18: 'var(--base-membership-18)',
  membership23: 'var(--base-membership-23)',
  membership27: 'var(--base-membership-27)',
  membership31: 'var(--base-membership-31)',
  membership35: 'var(--base-membership-35)',
  membership40: 'var(--base-membership-40)',
  membership44: 'var(--base-membership-44)',
  membership48: 'var(--base-membership-48)',
  membership53: 'var(--base-membership-53)',
  membership57: 'var(--base-membership-57)',
  membership61: 'var(--base-membership-61)',
  membership66: 'var(--base-membership-66)',
  membership70: 'var(--base-membership-70)',
  membership74: 'var(--base-membership-74)',
  membership79: 'var(--base-membership-79)',
  membership83: 'var(--base-membership-83)',
  membership87: 'var(--base-membership-87)',
  membership91: 'var(--base-membership-91)',
  membership96: 'var(--base-membership-96)',
  membership98: 'var(--base-membership-98)',
  membership99: 'var(--base-membership-99)',
  membership100: 'var(--base-membership-100)',
  neutral0: 'var(--base-neutral-0)',
  neutral15: 'var(--base-neutral-15)',
  neutral18: 'var(--base-neutral-18)',
  neutral23: 'var(--base-neutral-23)',
  neutral27: 'var(--base-neutral-27)',
  neutral31: 'var(--base-neutral-31)',
  neutral35: 'var(--base-neutral-35)',
  neutral40: 'var(--base-neutral-40)',
  neutral44: 'var(--base-neutral-44)',
  neutral48: 'var(--base-neutral-48)',
  neutral53: 'var(--base-neutral-53)',
  neutral57: 'var(--base-neutral-57)',
  neutral61: 'var(--base-neutral-61)',
  neutral66: 'var(--base-neutral-66)',
  neutral70: 'var(--base-neutral-70)',
  neutral74: 'var(--base-neutral-74)',
  neutral79: 'var(--base-neutral-79)',
  neutral83: 'var(--base-neutral-83)',
  neutral87: 'var(--base-neutral-87)',
  neutral91: 'var(--base-neutral-91)',
  neutral96: 'var(--base-neutral-96)',
  neutral98: 'var(--base-neutral-98)',
  neutral99: 'var(--base-neutral-99)',
  neutral100: 'var(--base-neutral-100)',
  orange0: 'var(--base-orange-0)',
  orange15: 'var(--base-orange-15)',
  orange18: 'var(--base-orange-18)',
  orange23: 'var(--base-orange-23)',
  orange27: 'var(--base-orange-27)',
  orange31: 'var(--base-orange-31)',
  orange35: 'var(--base-orange-35)',
  orange40: 'var(--base-orange-40)',
  orange44: 'var(--base-orange-44)',
  orange48: 'var(--base-orange-48)',
  orange53: 'var(--base-orange-53)',
  orange57: 'var(--base-orange-57)',
  orange61: 'var(--base-orange-61)',
  orange66: 'var(--base-orange-66)',
  orange70: 'var(--base-orange-70)',
  orange74: 'var(--base-orange-74)',
  orange79: 'var(--base-orange-79)',
  orange83: 'var(--base-orange-83)',
  orange87: 'var(--base-orange-87)',
  orange91: 'var(--base-orange-91)',
  orange96: 'var(--base-orange-96)',
  orange98: 'var(--base-orange-98)',
  orange99: 'var(--base-orange-99)',
  orange100: 'var(--base-orange-100)',
  purple0: 'var(--base-purple-0)',
  purple15: 'var(--base-purple-15)',
  purple18: 'var(--base-purple-18)',
  purple23: 'var(--base-purple-23)',
  purple27: 'var(--base-purple-27)',
  purple31: 'var(--base-purple-31)',
  purple35: 'var(--base-purple-35)',
  purple40: 'var(--base-purple-40)',
  purple44: 'var(--base-purple-44)',
  purple48: 'var(--base-purple-48)',
  purple53: 'var(--base-purple-53)',
  purple57: 'var(--base-purple-57)',
  purple61: 'var(--base-purple-61)',
  purple66: 'var(--base-purple-66)',
  purple70: 'var(--base-purple-70)',
  purple74: 'var(--base-purple-74)',
  purple79: 'var(--base-purple-79)',
  purple83: 'var(--base-purple-83)',
  purple87: 'var(--base-purple-87)',
  purple91: 'var(--base-purple-91)',
  purple96: 'var(--base-purple-96)',
  purple98: 'var(--base-purple-98)',
  purple99: 'var(--base-purple-99)',
  purple100: 'var(--base-purple-100)',
  red0: 'var(--base-red-0)',
  red15: 'var(--base-red-15)',
  red18: 'var(--base-red-18)',
  red23: 'var(--base-red-23)',
  red27: 'var(--base-red-27)',
  red31: 'var(--base-red-31)',
  red35: 'var(--base-red-35)',
  red40: 'var(--base-red-40)',
  red44: 'var(--base-red-44)',
  red48: 'var(--base-red-48)',
  red53: 'var(--base-red-53)',
  red57: 'var(--base-red-57)',
  red61: 'var(--base-red-61)',
  red66: 'var(--base-red-66)',
  red70: 'var(--base-red-70)',
  red74: 'var(--base-red-74)',
  red79: 'var(--base-red-79)',
  red83: 'var(--base-red-83)',
  red87: 'var(--base-red-87)',
  red91: 'var(--base-red-91)',
  red96: 'var(--base-red-96)',
  red98: 'var(--base-red-98)',
  red99: 'var(--base-red-99)',
  red100: 'var(--base-red-100)',
  taupe0: 'var(--base-taupe-0)',
  taupe15: 'var(--base-taupe-15)',
  taupe18: 'var(--base-taupe-18)',
  taupe23: 'var(--base-taupe-23)',
  taupe27: 'var(--base-taupe-27)',
  taupe31: 'var(--base-taupe-31)',
  taupe35: 'var(--base-taupe-35)',
  taupe40: 'var(--base-taupe-40)',
  taupe44: 'var(--base-taupe-44)',
  taupe48: 'var(--base-taupe-48)',
  taupe53: 'var(--base-taupe-53)',
  taupe57: 'var(--base-taupe-57)',
  taupe61: 'var(--base-taupe-61)',
  taupe66: 'var(--base-taupe-66)',
  taupe70: 'var(--base-taupe-70)',
  taupe74: 'var(--base-taupe-74)',
  taupe79: 'var(--base-taupe-79)',
  taupe83: 'var(--base-taupe-83)',
  taupe87: 'var(--base-taupe-87)',
  taupe91: 'var(--base-taupe-91)',
  taupe96: 'var(--base-taupe-96)',
  taupe98: 'var(--base-taupe-98)',
  taupe99: 'var(--base-taupe-99)',
  taupe100: 'var(--base-taupe-100)',
  teal0: 'var(--base-teal-0)',
  teal15: 'var(--base-teal-15)',
  teal18: 'var(--base-teal-18)',
  teal23: 'var(--base-teal-23)',
  teal27: 'var(--base-teal-27)',
  teal31: 'var(--base-teal-31)',
  teal35: 'var(--base-teal-35)',
  teal40: 'var(--base-teal-40)',
  teal44: 'var(--base-teal-44)',
  teal48: 'var(--base-teal-48)',
  teal53: 'var(--base-teal-53)',
  teal57: 'var(--base-teal-57)',
  teal61: 'var(--base-teal-61)',
  teal66: 'var(--base-teal-66)',
  teal70: 'var(--base-teal-70)',
  teal74: 'var(--base-teal-74)',
  teal79: 'var(--base-teal-79)',
  teal83: 'var(--base-teal-83)',
  teal87: 'var(--base-teal-87)',
  teal91: 'var(--base-teal-91)',
  teal96: 'var(--base-teal-96)',
  teal98: 'var(--base-teal-98)',
  teal99: 'var(--base-teal-99)',
  teal100: 'var(--base-teal-100)',
  yellow0: 'var(--base-yellow-0)',
  yellow15: 'var(--base-yellow-15)',
  yellow18: 'var(--base-yellow-18)',
  yellow23: 'var(--base-yellow-23)',
  yellow27: 'var(--base-yellow-27)',
  yellow31: 'var(--base-yellow-31)',
  yellow35: 'var(--base-yellow-35)',
  yellow40: 'var(--base-yellow-40)',
  yellow44: 'var(--base-yellow-44)',
  yellow48: 'var(--base-yellow-48)',
  yellow53: 'var(--base-yellow-53)',
  yellow57: 'var(--base-yellow-57)',
  yellow61: 'var(--base-yellow-61)',
  yellow66: 'var(--base-yellow-66)',
  yellow70: 'var(--base-yellow-70)',
  yellow74: 'var(--base-yellow-74)',
  yellow79: 'var(--base-yellow-79)',
  yellow83: 'var(--base-yellow-83)',
  yellow87: 'var(--base-yellow-87)',
  yellow91: 'var(--base-yellow-91)',
  yellow96: 'var(--base-yellow-96)',
  yellow98: 'var(--base-yellow-98)',
  yellow99: 'var(--base-yellow-99)',
  yellow100: 'var(--base-yellow-100)'
} as const);
export type PrimitiveColorTokensV2CssVarsType = typeof primitiveColorTokensV2CssVars;

/*
 * Colored "Herocon" material gradients — granular form.
 *
 * Herocons are applied mostly to SVG icons (e.g. star ratings), which cannot use
 * a CSS `linear-gradient()` string. Each entry ships the per-stop colors/offsets
 * plus the SVG axis (`svg`, objectBoundingBox 0–1) so a `<linearGradient>` can be
 * built in JS; the composed `css` string remains for CSS `background` consumers.
 * The same stop colors are also available as CSS custom properties
 * (`--base-<color>-background-material-bold-stop-<0|100>`) for static SVG markup.
 */
export const coloredMaterialBoldGradientsV2 = ({
  red: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#F43B00',
      position: 0
    }, {
      color: '#E42500',
      position: 100
    }],
    css: 'linear-gradient(to top left, #F43B00 0%, #E42500 100%)'
  },
  orange: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#FC993C',
      position: 0
    }, {
      color: '#FB762E',
      position: 100
    }],
    css: 'linear-gradient(to top left, #FC993C 0%, #FB762E 100%)'
  },
  yellow: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#F7E431',
      position: 0
    }, {
      color: '#F1D223',
      position: 100
    }],
    css: 'linear-gradient(to top left, #F7E431 0%, #F1D223 100%)'
  },
  green: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#0CA555',
      position: 0
    }, {
      color: '#098042',
      position: 100
    }],
    css: 'linear-gradient(to top left, #0CA555 0%, #098042 100%)'
  },
  blue: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#1697E7',
      position: 0
    }, {
      color: '#1175DD',
      position: 100
    }],
    css: 'linear-gradient(to top left, #1697E7 0%, #1175DD 100%)'
  },
  crimson: {
    direction: 'to top left',
    svg: {
      x1: 1,
      y1: 1,
      x2: 0,
      y2: 0
    },
    stops: [{
      color: '#E0336C',
      position: 0
    }, {
      color: '#D32753',
      position: 100
    }],
    css: 'linear-gradient(to top left, #E0336C 0%, #D32753 100%)'
  }
} as const);
export type ColoredMaterialBoldGradientsV2Type = typeof coloredMaterialBoldGradientsV2;